<template>
  <hcm-card
    :resource="resource"
    :resourceUrl="'/detail/' + resource.type + '/' + resource.uuid"
    :externalResource="false"
    :hasSource="false"
    :hasShare="false"
  >
    <div class="content-summary">
      {{ resource.summary }}
    </div>
    <div class="content-detail">
      <span v-html="formattedDescription"></span>
    </div>
  </hcm-card>
</template>

<script>
import HCMCard from "./HCMCard.vue";
import marked from "marked";

export default {
  components: { "hcm-card": HCMCard },
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  computed: {
    shareTag() {
      return "Text clip";
    },
    shareTitle() {
      return this.resource.title;
    },
    shareUrl() {
      return `${window.location.origin}/detail/TextItem/${this.resource["uuid"]}`;
    },
    formattedDescription() {
      const link_renderer = function() {
        var render = new marked.Renderer();

        // render links with target=_blank
        render.link = function(href, title, text) {
          return '<a href= "' + href + '" target="_blank">' + text + "</a>";
        };

        return render;
      };

      return marked(this.resource.description, { renderer: link_renderer() });
    }
  }
};
</script>

<style scoped>
.content-detail {
  margin-top: 20px;
}

::v-deep hr {
  margin: 40px 0px;
  height: 1px;
}
</style>
